import { render, staticRenderFns } from "./logs_admin_dialog.vue?vue&type=template&id=196e008e&scoped=true&"
import script from "./logs_admin_dialog.vue?vue&type=script&lang=js&"
export * from "./logs_admin_dialog.vue?vue&type=script&lang=js&"
import style0 from "./logs_admin_dialog.vue?vue&type=style&index=0&id=196e008e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "196e008e",
  null
  
)

export default component.exports